module.exports = __webpack_public_path__ + "img/get-tip@2x.a88500c8.png";